import React from "react";
import { Row, Col } from "antd";
import "./StepNavigationBar.scss";

const StepNavigationBar = ({ currentStep = 1, onStepClick, isAdmin = false }) => {
  const steps = isAdmin
    ? [
        { number: 1, label: "Service Selection" },
        { number: 2, label: "Locations" },
        { number: 3, label: "Route Optimization" },
        { number: 4, label: "Confirm" }
      ]
    : [
        { number: 1, label: "Locations" },
        { number: 2, label: "Confirm Locations" },
        { number: 3, label: "Service Selection" },
        { number: 4, label: "Confirm" }
      ];

  const handleStepClick = (stepNumber) => {
    // Allow clicking on completed steps to go back
    if (stepNumber < currentStep && onStepClick) {
      onStepClick(stepNumber);
    }
  };

  return (
    <div className="step-navigation-bar">
      <Row gutter={[16, 16]} align="middle" justify="space-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <Col>
              <div
                onClick={() => handleStepClick(step.number)}
                className={`step-item ${step.number === currentStep ? "active" : ""} ${
                  step.number < currentStep ? "completed" : ""
                } ${step.number > currentStep ? "disabled" : ""}`}
                style={{
                  cursor: step.number < currentStep ? "pointer" : "default"
                }}
              >
                <div className="step-circle">{step.number}</div>
                <div className="step-label">{step.label}</div>
              </div>
            </Col>
            {index < steps.length - 1 && (
              <Col flex="auto">
                <div
                  className={`step-connector ${
                    step.number < currentStep ? "completed" : ""
                  }`}
                />
              </Col>
            )}
          </React.Fragment>
        ))}
      </Row>
    </div>
  );
};

export default StepNavigationBar;
